import React from 'react';
import PropTypes from 'prop-types';
import s from './Grid.module.scss';
import classNames from 'classnames';

const Grid = ({
    columns = 1,
    modifier = '',
    theme = '',
    children,
    className,
    isFullHeight,
}) => {
    const classes = classNames(
        s.Root,
        className,
        s[`Root--${columns}`],
        s[`Root--${modifier}`],
        { [s['Root--FullHeight']]: isFullHeight },
        { [s[`Root--Theme-${theme}`]]: !!theme }
    );

    return <div className={classes}>{children}</div>;
};

Grid.propTypes = {};

export default Grid;
